import { InsuranceCompaniesService } from 'data/services';
import { InsuranceCompaniesServiceInterface } from 'domain/services';
import { makeRemoteGetAllInsuranceCompanies } from 'main/factories/usecases/insure-companies/get-all-insurance-companies';

export const makeInsuranceCompaniesService =
  (): InsuranceCompaniesServiceInterface => {
    return new InsuranceCompaniesService({
      getAllInsuranceCompanies: makeRemoteGetAllInsuranceCompanies(),
    });
  };
